<div *ngIf="viewContactPerson">
    <div class="border p-3 rounded shadow-sm">
        <div class="row g-2 align-items-center">
            <div class="col-lg-5">
                <div class="row">
                    <div class="col-6">
                        <p class="mb-1"><strong>{{ 'Vendor ID' | wordReplace }}</strong> : {{vendorMarketID}}</p>
                        <p class="mb-1"><strong>Name</strong> : {{vendorName}}</p>
                    </div>
                    <div class="col-6">
                        <p class="mb-1"><strong>Telephone</strong> : {{telephone | phoneFormat}}</p>
                        <p class="mb-1"><strong>Email</strong> : {{Email}}</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-7 d-flex align-items-center gap-2">
                <button class="btn btnAS me-1" (click)="createContactPerson()">Create New</button>
                <button class="btn btn-orange" (click)="goBack()">Back</button>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-start my-2">
            <h6 class="fw-bold">Contact Person</h6>
            <ejs-grid [dataSource]="vendorContactData" height="350" (rowSelected)="onContactRowSelected($event)">
                <e-columns>
                    <e-column field="ContactName" headerText="Name" width="200" textAlign="Left"></e-column>
                    <e-column field="Address" headerText="Address" width="180" textAlign="Left"></e-column>
                    <e-column field="City" headerText="City" width="140" textAlign="Left"></e-column>
                    <e-column field="State" headerText="State" width="120" textAlign="Left"></e-column>
                    <e-column field="TelePhone" headerText="Telephone#" width="150" textAlign="Left"></e-column>
                    <e-column field="ZipCode" headerText="Zipcode" width="120" textAlign="Left"></e-column>
                    <e-column field="EmailAddr" headerText="E-mail Address" width="200" textAlign="Left"></e-column>
                    <e-column field="IsAuthorized" headerText="Authorized" width="120" textAlign="Center">
                        <ng-template #template let-data>
                            <input type="checkbox" class="form-check-input" [checked]="data.IsAuthorised" disabled />
                        </ng-template>
                    </e-column>
                    <e-column field="Remove" headerText="Delete" width="100" textAlign="Center">
                        <ng-template #template let-data>
                            <div (click)="deleteVendorContactPerson(data); $event.stopPropagation()">
                                <a>
                                    <img src="./assets/images/delete.svg" class="img-fluid" />
                                </a>
                            </div>
                        </ng-template>
                    </e-column>
                </e-columns>
            </ejs-grid>
        </div>
    </div>
</div>
<div *ngIf="!viewContactPerson" [formGroup]="vendorContactForm">
    <div class="row align-items-start form-row-gap mb-2">
        <div class="col-md-6 col-lg-3">
            <label class="form-label-small" for="firstName">First Name<span class="text-danger">*</span></label>
            <input id="firstName" name="firstName" class="form-control light-input" type="text"
                formControlName="FirstName" maxlength="40">
            <div *ngIf="
                vendorContactForm.get('FirstName')?.invalid &&
                vendorContactForm.get('FirstName')?.touched
                " class="text-danger small">
                <ng-container *ngIf="vendorContactForm.get('FirstName')?.errors?.['required']">
                    First name is required.
                </ng-container>
            </div>
        </div>
        <div class="col-md-6 col-lg-3">
            <label class="form-label-small" for="firstName">Middle Name</label>
            <input id="firstName" name="firstName" class="form-control light-input" type="text"
                formControlName="MiddleName" maxlength="40">
        </div>
        <div class="col-md-6 col-lg-3">
            <label class="form-label-small" for="lastName">Last Name</label>
            <input id="lastName" name="lastName" class="form-control light-input" type="text" formControlName="LastName"
                maxlength="40">
        </div>
        <div class="col-md-6 col-lg-3">
            <label class="form-label-small" for="address">Address<span class="text-danger">*</span></label>
            <input id="address" name="address" class="form-control light-input" type="text" formControlName="Address"
                maxlength="50">
            <div *ngIf="
                vendorContactForm.get('Address')?.invalid &&
                vendorContactForm.get('Address')?.touched
                " class="text-danger small">
                <ng-container *ngIf="vendorContactForm.get('Address')?.errors?.['required']">
                    Address is required.
                </ng-container>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-10">
            <div class="row align-items-start form-row-gap mb-2">
                <div class="col-md-6 col-lg-3">
                    <label class="form-label-small" for="city">City<span class="text-danger">*</span></label>
                    <input id="city" name="city" class="form-control light-input" type="text" placeholder=""
                        formControlName="City" maxlength="30">
                    <div *ngIf="
                        vendorContactForm.get('City')?.invalid &&
                        vendorContactForm.get('City')?.touched
                        " class="text-danger small">
                        <ng-container *ngIf="vendorContactForm.get('City')?.errors?.['required']">
                            City is required.
                        </ng-container>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="form-label-small" for="state">State<span class="text-danger">*</span></label>
                    <!-- Dropdown when states are available -->
                    <select *ngIf="statesAvailable" name="state" id="state" class="form-select"
                        formControlName="StateCode">
                        <option [value]="null" disabled>Select</option>
                        @for (state of states; track state.StateCode) {
                        <option [value]="state.StateCode">{{ state.StateName }}</option>
                        }
                    </select>
                    <!-- Input when no states are available -->
                    <input *ngIf="!statesAvailable" name="state" id="state" type="text" class="form-control"
                        formControlName="StateCode" placeholder="Enter State" maxlength="30" />
                    <div *ngIf="
                        vendorContactForm.get('StateCode')?.invalid &&
                        vendorContactForm.get('StateCode')?.touched
                        " class="text-danger small">
                        <ng-container *ngIf="vendorContactForm.get('StateCode')?.errors?.['required']">
                            State is required.
                        </ng-container>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="form-label-small" for="country">Country</label>

                    <select class="form-select light-input" id="country" formControlName="CountryCode" name="country"
                        (change)="onCountryChange($event)" aria-label="Country select">
                        <option [value]="null" disabled>Select</option>
                        @for (c of countries; track c.Code) {
                        <option [value]="c.Code">{{ c.Name }}</option>
                        }
                    </select>
                </div>
                <div class="col-md-6 col-lg-3">
                    <label class="form-label-small" for="zip">Zip / Postal Code<span
                            class="text-danger">*</span></label>
                    <input id="zip" name="zip" class="form-control light-input" type="text" formControlName="ZipCode"
                        maxlength="10">
                    <div *ngIf="
                        vendorContactForm.get('ZipCode')?.invalid &&
                        vendorContactForm.get('ZipCode')?.touched
                        " class="text-danger small">
                        <ng-container *ngIf="vendorContactForm.get('ZipCode')?.errors?.['required']">
                            Zip / Postal Code is required.
                        </ng-container>
                        <ng-container *ngIf="vendorContactForm.get('ZipCode')?.errors['pattern']">
                            <ng-container [ngSwitch]="selectedCountryCode">
                                <span *ngSwitchCase="ECountrycode.US">
                                    Enter a valid Zip Code (e.g., 12345 or 12345-6789).
                                </span>
                                <span *ngSwitchCase="ECountrycode.CA">
                                    Enter a valid Postal Code (e.g., A1A 1A1).
                                </span>
                                <span *ngSwitchDefault>
                                    Invalid Zip / Postal Code.
                                </span>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="row align-items-start form-row-gap mb-2">
                <div class="col-md-6 col-lg-3">
                    <label class="form-label-small" for="email">Email<span class="text-danger">*</span></label>
                    <input id="email" name="email" class="form-control light-input" type="email"
                        formControlName="EmailAddr">
                    <div *ngIf="
                        vendorContactForm.get('EmailAddr')?.invalid &&
                        vendorContactForm.get('EmailAddr')?.touched
                        " class="text-danger small">
                        <ng-container *ngIf="vendorContactForm.get('EmailAddr')?.errors?.['required']">
                            Email address is required.
                        </ng-container>
                        <ng-container *ngIf="vendorContactForm.get('EmailAddr')?.errors?.['pattern']">
                            Enter a valid email address.
                        </ng-container>
                    </div>
                </div>

                <div class="col-md-6 col-lg-3">
                    <label class="form-label" for="telephone">Telephone<span class="text-danger">*</span></label>
                    <ejs-maskedtextbox [mask]="PhoneNumberMask" name="telephone" id="telephone"
                        formControlName="TelePhone"></ejs-maskedtextbox>
                    <div *ngIf="
                        vendorContactForm.get('TelePhone')?.invalid &&
                        vendorContactForm.get('TelePhone')?.touched
                        " class="text-danger small">
                        <ng-container *ngIf="vendorContactForm.get('TelePhone')?.errors?.['required']">
                            Telephone number is required.
                        </ng-container>
                    </div>
                </div>
                <div class="col-md-6 col-lg-3 mt-4">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="authorizePayments"
                            formControlName="IsAuthorised">
                        <label class="form-check-label" for="authorizePayments">
                            Authorized to Collect Payments
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 my-2 d-flex align-items-center">
            <!-- Logo box -->
            <div class="logo-box relative me-3" style="margin-left: 0px !important;">
                <div class="w-100 h-100 d-flex align-items-center justify-content-center p-1">
                    <img [src]="logoPreviewUrl || '../assets/images/NoPhoto.svg'" alt="Vendor Logo" id="logoPreview"
                        class="img-fluid" style="pointer-events: none;">
                </div>
            </div>
            <!-- Buttons -->
            <div class="d-flex flex-column">
                <button class="btn btnAS mb-2" type="button" (click)="addContactImageClick()">ADD</button>
                <button class="btn btnAS mb-2" type="button" (click)="removeContactPersonImage()">REMOVE</button>
            </div>
            <!-- Hidden file input for main image -->
            <input type="file" id="contactImageInput" (change)="addContactPersonImage($event)" accept=".jpg,.jpeg,.png"
                hidden>
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-end my-2">
            <button id="btnMarketSave" type="button" class="btn btnAS me-1" (click)="saveVendorContactPerson()">
                {{ isEditMode ? 'Update'
                : 'Save' }}
            </button>
            <button class="btn btn-orange" type="button" (click)="closeCreateContactPerson()">Cancel</button>
        </div>
    </div>
</div>